<template>
  <div class="container">

    <div class="mb-4">
     <h3><span>Émetteur</span></h3>
     <v-text-field background-color="white" outlined style="padding-top: 0 !important;" class="subject-input" :value="webForm.email_from" disabled>
     </v-text-field>
    </div>

    <div class="mb-4">
    <h3><span>Objet</span></h3>
      <v-text-field background-color="white" outlined style="padding-top: 0 !important;" class="subject-input" :value="webForm.subject" disabled>
      </v-text-field>
    </div>

    <h3><span>Contenu de l'email</span></h3>
    <v-card>
      <v-card-text>
        <div class="mb-4">
          <b>{{ webForm.subject }}</b>
        </div>
        <div v-html="webForm.content" class="mb-3" style="pointer-events: none"></div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import ClassicEditor from '../../../../plugins/ckeditor'
import {mapState} from "vuex"

export default {
  name: "EmailReadOnly",
  props:['webForm'],
  components: {},
  data() {
    return {
      editor: ClassicEditor,
      preview: false,
    }
  },
  computed: {
    ...mapState('account', ['token']),
  },
  created() {
    this.editor.defaultConfig.simpleUpload.headers = {
      Authorization: 'Bearer ' + this.token
    }
  }
}
</script>

